require('./transferMoneyStep1.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { getLanguage, FormattedText, formatText } = require('core/i18n').i18n;

// @ utilities
const { getCurrencySymbol, getFormattedString } = require('utilities/currencyHelper');
// @ actions
const cardTransferMoneyActions = require('actions/cardTransferMoney');
// @ components
const { AmountInput } = require('commonsComponents/amountInput');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @constants
const { CARD_TRANSFER_MINIMUM_AMOUNT, CARD_TRANSFER_COMMISSION_PERCENT } = require('constants/index');

class TransferMoneyStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);

        this.state = {
            currentAmount: props.immStep.get('amount')
        }
    }

    buildDropdownAccounts(accountsIndexes) {
        const { immAccounts, isInactiveAccountsEnabled } = this.props;
        const tooltipMsgContent = isInactiveAccountsEnabled ? 'inactiveAccounts-inactiveAccounts_dropdownCommonToolTip' : '';

        if (immAccounts.size) {
            return (
                <DropdownAccounts
                    label={formatText('cardTransferMoney-chargeAccount')}
                    id="drd_TransferMoneyStep1_Account"
                    immAccounts={immAccounts}
                    accountsIndexes={accountsIndexes}
                    value={accountsIndexes}
                    enabled={false}
                    currentAccountId={accountsIndexes[0]}
                    onAccountChange={this.handleFromAccountChange}
                    showAvailableBalance={true}
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    tooltipMsg={tooltipMsgContent}
                />
            );
        } else {
            return (<LoadingSection />);
        }
    }

    handleChange(value) {
        this.setState({
            currentAmount: value
        })
    }

    handleBlur(value) {
        this.setState({
            currentAmount: value
        });
        this.props.handleAmountChange(value);
    }

    render() {
        const { immCard, immStep, immAccounts, accountsIndexes } = this.props;
        const amount = immStep.get('amount');
        const currency = getCurrencySymbol(immCard.get('availableBalance'));
        const dropdownAccounts = this.buildDropdownAccounts(accountsIndexes);
        const formattedTotalContractBalanceDrawn = getFormattedString(immCard.get('availableBalance'));
        const amountRequiredAlertVisible = immStep.get('amountIsDirty') && amount < CARD_TRANSFER_MINIMUM_AMOUNT;
        const amountGreaterThanAccountBalance = immStep.get('amountIsDirty') && immAccounts && amount > immStep.get('totalAvailableBalance');
        const isAmountMultiple100 = immStep.get('amountIsDirty') && amount % 100 != 0;

        const minimumAmount = CARD_TRANSFER_MINIMUM_AMOUNT;
        const injectedStrings = [
            getFormattedString({ amount: minimumAmount, currency })
        ];
        const commission = [
            getFormattedString({ amount: isNaN(this.state.currentAmount) ? 0 : this.state.currentAmount * CARD_TRANSFER_COMMISSION_PERCENT * 0.01, currency })
        ];
        let errorMsg = '';
        if (amountRequiredAlertVisible) {
            errorMsg = formatText('cardTransferMoney-minimumAmountErrorMessage', injectedStrings);
        } else if (amountGreaterThanAccountBalance) {
            errorMsg = formatText('cardTransferMoney-maximumAmountErrorMessage');
        } else if (isAmountMultiple100) {
            errorMsg = formatText('cardTransferMoney-multiple100AmountErrorMessage');
        }

        const amountInputValidationErrorMessage = !(amountRequiredAlertVisible || amountGreaterThanAccountBalance || isAmountMultiple100) && <FormattedText value="cardTransferMoney-defaultInputMessage" className="transfer-money-step-one__clarification" injectedStrings={[formattedTotalContractBalanceDrawn]} />

        return (
            <article className="transfer-money-step-one">
                <header className="transfer-money-step-one__header">
                    <FormattedText value="cardTransferMoney-applicationDataMessageTitle" className="transfer-money-step-one__title" />
                </header>
                <section className="transfer-money-step-one__content">
                    <FormattedText value="cardTransferMoney-applicationDataMessage" />
                    <div className="transfer-money-step-one__form">
                        <fieldset className="transfer-money-step-one__field">
                            {dropdownAccounts}
                        </fieldset>
                        <fieldset className="transfer-money-step-one__field">
                            <label>
                                <FormattedText value="cardTransferMoney-amountToBePaid" className="transfer-money-step-one__label" />
                                <AmountInput
                                    id="inp_TransferMoneyStep1_Amount"
                                    callback={(value) =>{this.handleBlur(value)}}
                                    onChange={this.handleChange}
                                    min={0}
                                    showBlurZero
                                    hideFocusZero
                                    disablePaste
                                    errorMsg={errorMsg}
                                    error={amountRequiredAlertVisible || amountGreaterThanAccountBalance || isAmountMultiple100}
                                    amount={this.state.currentAmount}
                                    language={getLanguage()}
                                />
                            </label>
                            <span className="transfer-money-step-one__currency">
                                {currency}
                            </span>
                            {amountInputValidationErrorMessage}
                            <FormattedText className="transfer-money-step-one__clarification" value="cardTransferMoney-commissionMessage" injectedStrings={[commission]} />
                        </fieldset>
                    </div>
                </section>
            </article>
        )
    }
}

TransferMoneyStep1.propTypes = {
    immCard: PropTypes.object,
    immStep: PropTypes.object,
    immAccounts: PropTypes.object,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    accountsIndexes: PropTypes.array,
    handleAmountChange: PropTypes.func,
    setFromAccount: PropTypes.func
};

module.exports.constructor = TransferMoneyStep1;
module.exports.TransferMoneyStep1 = connect(null,
    {
        handleAmountChange: cardTransferMoneyActions.setAmount,
        setFromAccount: cardTransferMoneyActions.setFromAccount
    }
)(TransferMoneyStep1);
